import { useContext, useEffect } from "react";

import { Container, Grid } from "@material-ui/core";

import Loading from "../../../components/basics/Loading";

import Btn from "../../../components/buttons/Btn";

import AccordionDadosGerais from "./children/AccordionDadosGerais";
import HeaderModule from "../../../components/header/HeaderModule";
import { Margin } from "../../../theme/styles/Utils";
import { MotivoCancelamentoContext } from "./context/MotivoCancelamentoContext";
import useMotivoCancelamentoController from "./controllers/MotivoCancelamentoController";
import { Line } from "./styles/MotivoCancelamento";
import { GlobalVariables } from "../../../GlobalVariables";

const MotivoCancelamentoCadastro = ({ location }) => {
  const { loading } = useContext(MotivoCancelamentoContext);

  const { storeAndUpdate, back, handleSetData } =
    useMotivoCancelamentoController();

  useEffect(() => {
    handleSetData(location?.state?.id);
  }, [handleSetData, location]);

  return (
    <>
      <Loading open={loading} />
      <HeaderModule
        title="CADASTRO DE MOTIVO DE CANCELAMENTO"
        videoId={GlobalVariables.screenVideosIds.cadastroMotivoCancelamento}
      />
      <Margin top="100">
        <Container maxWidth="xl">
          <AccordionDadosGerais />

          <Line container spacing={1} justifyContent="flex-end">
            <Grid item>
              <Btn
                label="Voltar"
                hovercolor="darkred"
                bgcolor="tertiary"
                onClick={back}
              />
            </Grid>
            <Grid item>
              <Btn
                label="Salvar"
                onClick={() => {
                  storeAndUpdate();
                }}
              />
            </Grid>
            <Grid item>
              <Btn
                label="Salvar e Novo"
                onClick={() => {
                  storeAndUpdate(true);
                }}
              />
            </Grid>
          </Line>
        </Container>
      </Margin>
    </>
  );
};

export default MotivoCancelamentoCadastro;
